import React, { createContext, Dispatch, ReactNode } from 'react';

const CampaignContext = createContext({
  campaignId: null,
  setCampaignId: null,
});

interface CampaignProviderProps {
  campaignId: number;
  setCampaignId: Dispatch<any>;
  children: ReactNode;
}

const CampaignProvider: React.FC<CampaignProviderProps> = ({
  campaignId,
  setCampaignId,
  children,
}) => {
  return (
    <CampaignContext.Provider value={{ campaignId, setCampaignId }}>
      {children}
    </CampaignContext.Provider>
  );
};

const useCampaign = () => {
  return React.useContext(CampaignContext);
};

export { CampaignContext, CampaignProvider, useCampaign };
